<template>
  <div class="ai">
    <div class="cont">
      <div class="selectCont">
        <div
          v-bind:class="item.id === setid ? 'resitem resitemactive' : 'resitem'"
          v-for="item in tablist"
          :key="item.id"
          @click="changeTab(item.id)"
        >
          <div class="p1">{{ item.name }}</div>
        </div>
      </div>

      <div
        v-if="setid === 1"
        class="tableCont"
        v-loading="loading"
        element-loading-text="内容生成中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
      >
        <div>
          <div class="scbox">
            <el-input
              placeholder="请输入职位名称"
              v-model="posname"
              style="width: 55vw"
            >
              <template slot="prepend">请帮我生成一个</template>
              <template slot="append">（输入职位名称,关键词）职位的JD</template>
            </el-input>

            <el-result v-if="posloading" icon="info" title="信息提示" subTitle="职位生成中，请稍等"></el-result>



            <el-button  v-if="!posloading" class="scbtn" type="primary" @click="getJd()"
              >生成</el-button
            >

            <el-tabs v-if="tjres.length > 0" v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane
                v-for="(item, index) in tjres"
                :key="index"
                :label="item.basic_info.name"
                :name="item._id"
              >
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>{{
                      `${item.basic_info.name}(${item.basic_info.current_position})`
                    }}</span>
                  </div>
                  <div class="text1 item">
                    {{ `年龄：` }}
                  </div>
                  <div class="text item">
                    {{ `${item.basic_info.age}岁` }}
                  </div>
                  <div class="text1 item">
                    {{ `学历:` }}
                  </div>
                  <div class="text item">
                    {{ `${item.basic_info.degree}` }}
                  </div>
                  <div class="text1 item">
                    {{ `工作年限:` }}
                  </div>
                  <div class="text item">
                    {{ `${item.basic_info.num_work_experience}年` }}
                  </div>

                  <div class="text1 item">
                    {{ `工作历史：` }}
                  </div>

                  <div
                    class="text item"
                    v-for="(item2, index) in item.work_experience"
                    :key="{ index }"
                  >
                    {{
                      `${item.work_experience[index].company_name}---${item.work_experience[index].job_title}(${item.work_experience[index].start_time_year}~${item.work_experience[index].end_time_year}):\n\n${item.work_experience[index].description}`
                    }}
                  </div>
                  <div class="text1 item">
                    {{ `适合职位:` }}
                  </div>
                  <div class="text item">
                    {{ `${item.hsgz.toString(',')}` }}
                  </div>
                  <div class="text1 item">
                    {{ `候选人关键词:` }}
                  </div>
                  <div class="text item">
                    {{ `${item.tags.toString(',')}` }}
                  </div>
                </el-card>
              </el-tab-pane>
            </el-tabs>

            <el-card v-if="resinfo" class="box-card">
              <div slot="header" class="clearfix">
                <span>{{
                  `${resinfo.basic_info.name}(${resinfo.basic_info.current_position})`
                }}</span>
              </div>
              <div class="text1 item">
                {{ `年龄：` }}
              </div>
              <div class="text item">
                {{ `${resinfo.basic_info.age}岁` }}
              </div>
              <div class="text1 item">
                {{ `学历:` }}
              </div>
              <div class="text item">
                {{ `${resinfo.basic_info.degree}` }}
              </div>
              <div class="text1 item">
                {{ `工作年限:` }}
              </div>
              <div class="text item">
                {{ `${resinfo.basic_info.num_work_experience}年` }}
              </div>
              <div class="text1 item">
                {{ `工作历史：` }}
              </div>

              <div
                class="text item"
                v-for="(item2, index) in resinfo.work_experience"
                :key="{ index }"
              >
                {{
                  `${resinfo.work_experience[index].company_name}---${resinfo.work_experience[index].job_title}(${resinfo.work_experience[index].start_time_year}~${resinfo.work_experience[index].end_time_year}):\n\n${resinfo.work_experience[index].description}`
                }}
              </div>
              <div class="text1 item">
                {{ `项目历史` }}
              </div>

              <div
                class="text item"
                v-for="(item2, index) in resinfo.project_experience"
                :key="{ index }"
              >
              {{
                  `${resinfo.project_experience[index].project_name}(${resinfo.project_experience[index].start_time_year}~${resinfo.project_experience[index].end_time_year})\n\n${resinfo.project_experience[index].description}`
                }}
              </div>
            </el-card>
            <el-card v-if="posinfo" class="box-card">
              <div slot="header" class="clearfix">
                <span>{{ posinfo.des1.content }}</span>
                <el-button
                  @click="getResByname(posinfo)"
                  style="float: right; padding: 3px 0; margin-left: 10px"
                  type="text"
                  >匹配现有简历</el-button
                >
                <el-button
                  @click="goTestRes()"
                  style="float: right; padding: 3px 0; margin-left: 10px"
                  type="text"
                  >测试简历是否匹配</el-button
                >
                <el-button
                  @click="gosendPos()"
                  style="float: right; padding: 3px 0"
                  type="text"
                  >去发职位</el-button
                >
              </div>
              <div class="text1 item">
                {{ posinfo.des2.titel }}
              </div>
              <pre class="text item">
                {{ posinfo.des2.content.trim() }}
              </pre>
              <div class="text1 item">
                {{ posinfo.des3.titel }}
              </div>
              <pre class="text item">
                {{ posinfo.des3.content.trim() }}
              </pre>
              <div class="text1 item">
                {{ posinfo.des4.titel }}
              </div>
              <pre class="text item">
                {{ posinfo.des4.content.trim() }}
              </pre>
            </el-card>
          </div>
        </div>
      </div>

      <div
        v-if="setid === 2"
        class="tableCont"
        v-loading="loading"
        element-loading-text="内容生成中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
      >
        <div>
          <div class="scbox">

            <el-card  class="box-card1" id="box-card1">
                <div v-for="(item,index) in twlist"  :key="index"   class="tbox">
                    <div  class="myinfo">
                        <div class="name">
                          {{ userStatus.nickname }}
                        </div>
                        <div class="textbox">
                          {{ item.text }}
                        </div>
                    </div>
                    <div class="gptinfo">
                        <div class="name">
                          聘小快
                        </div>
                        <div class="textbox">
                          {{ item.state === 'success' ? item.res  : '正在回答中' }}
                        </div>
                    </div>
                </div>
            </el-card>
            <div class="twbox">
              <el-input placeholder="请输入你的问题" v-model="tw">
              <template slot="prepend">你想问什么</template>
            </el-input>
            <el-button class="scbtn" type="primary" @click="getTw()"
              >提问</el-button
            >
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="setid === 3"
        class="tableCont"
        v-loading="loading"
        element-loading-text="内容生成中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
      >
        <div>

          
          <div class="scbox">
            <el-upload
              class="upload-demo udpc"
              style="margin: 10px auto"
              drag
              ref="upload"
              limit="1"
              :on-success="handleAvatarSuccess1"
              :data="{ user: user }"
              accept=".doc,.pdf,.docx"
              action=" https://api.qilinpin.cn/gptapi/api/uploadRes"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div style="margin: 10px auto" class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">只能上传docx/pdf文件</div>
            </el-upload>


            <el-card v-if="getResTagInfo" class="box-card">
              <div slot="header" class="clearfix">
                <span>{{
                  '简历分析'
                }}</span>
                </div>
                <div class="text1 item">
                {{ `职位1分析：` }}
              </div>
              <div class="text item">
                {{ `${getResTagInfo.result1 === '' ? '加载中' : getResTagInfo.result1}` }}

              </div>
              <div class="text1 item">
                {{ `职位2分析：` }}
              </div>
              <div class="text item">
                {{ `${getResTagInfo.result2 === '' ? '加载中' : getResTagInfo.result2}` }}

              </div>
              <div class="text1 item">
                {{ `简历总评：` }}
              </div>
              <div class="text item">
                {{ `${getResTagInfo.res === '' ? '加载中' : getResTagInfo.res}` }}
              </div>
                </el-card>


            <el-card v-if="resinfo" class="box-card">
              <div slot="header" class="clearfix">
                <span>{{
                  `${resinfo.basic_info.name}(${resinfo.basic_info.current_position})`
                }}</span>
                <el-button
                  @click="getResTag()"
                  style="float: right; padding: 3px 0; margin-left: 10px"
                  type="text"
                  >分析简历</el-button
                >
                <el-button
                  @click="createLtDoc()"
                  style="float: right; padding: 3px 0; margin-left: 10px"
                  type="text"
                  >猎头报告</el-button
                >

              </div>


              <div class="text1 item">
                {{ `年龄：` }}
              </div>
              <div class="text item">
                {{ `${resinfo.basic_info.age}岁` }}
              </div>
              <div class="text1 item">
                {{ `学历:` }}
              </div>
              <div class="text item">
                {{ `${resinfo.basic_info.degree}` }}
              </div>
              <div class="text1 item">
                {{ `工作年限:` }}
              </div>
              <div class="text item">
                {{ `${resinfo.basic_info.num_work_experience}年` }}
              </div>
              <div class="text1 item">
                {{ `公司：` }}
              </div>
              <div class="text item">
                {{ `${resinfo.work_experience[0].company_name}` }}
              </div>
              <div class="text1 item">
                {{ `部门:` }}
              </div>
              <div class="text item">
                {{ `${resinfo.work_experience[0].department}` }}
              </div>
              <div class="text1 item">
                {{ `工作历史：` }}
              </div>

              <el-card
                class="text item"
                v-for="(item2, index) in resinfo.work_experience"
                :key="{ index }"
              >

              <div slot="header" class="clearfix">
                <span>{{
                  `${resinfo.work_experience[index].company_name}---${resinfo.work_experience[index].job_title}(${resinfo.work_experience[index].start_time_year}~${resinfo.work_experience[index].end_time_year})`
                }}</span>
                <el-button
                  @click="getYhRes(index,resinfo.work_experience[index].description)"
                  style="float: right; padding: 3px 0; margin-left: 10px"
                  type="text"
                  >AI优化</el-button
                >
              </div>
                {{
                  `${resinfo.work_experience[index].description}`
                }}
              </el-card>
              <div class="text1 item">
                {{ `项目历史：` }}
              </div>

              <el-card
                class="text item"
                v-for="(item2, index) in resinfo.project_experience"
                :key="{ index }"
              >

              <div slot="header" class="clearfix">
                <span>{{
                  `${resinfo.project_experience[index].project_name}(${resinfo.project_experience[index].start_time_year}~${resinfo.project_experience[index].end_time_year})`
                }}</span>
                <el-button
                  @click="getYhRes1(index,resinfo.project_experience[index].description)"
                  style="float: right; padding: 3px 0; margin-left: 10px"
                  type="text"
                  >AI优化</el-button
                >
              </div>
                {{
                  `${resinfo.project_experience[index].description}`
                }}
              </el-card>
            </el-card>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="上传简历"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>上传简历</span>

      <el-upload
        class="upload-demo udpc"
        style="margin: 10px auto"
        drag
        ref="upload"
        limit="1"
        :on-success="handleAvatarSuccess"
        :data="{ user: user }"
        accept=".doc,.pdf,.docx"
        action=" https://api.qilinpin.cn/gptapi/api/uploadRes"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div style="margin: 10px auto" class="el-upload__text">
          将文件拖到此处，或<em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">只能上传docx/pdf文件</div>
      </el-upload>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Config from '../config/index'
import OSS from 'ali-oss'
import qs from 'qs'
import MyCropper from './cropper.vue'
import { Message } from 'element-ui'
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";


let client = new OSS({
  region: 'oss-cn-beijing',
  accessKeySecret: 'mPTRYqVIIWC8XxSeZqKFMPtFMWMfb5', // AccessKeySecret 去你的阿里云上控制台上找
  accessKeyId: 'LTAIvBaMapD5qPW9', // AccessKeyId 去你的阿里云上控制台上找
  bucket: 'linkedln',
  endpoint: 'images.qilinpin.cn',
  cname: true,
  secure: true,
})

function loadFile(url, callback) {
    PizZipUtils.getBinaryContent(url, callback);
}

export default {
  name: 'ai',
  props: {},
  components: { MyCropper },
  data() {
    return {
      userStatus: this.$store.state.userStatus,
      activeName: '',
      user: localStorage.getItem('token'),
      dialogVisible: false,
      loading: false,
      resinfo: false,
      posinfoid: false,
      posloading: false,
      posinfo: false,
      twinfo: false,
      tjres: [],
      posname: '',
      tw: '',
      setid: 1,
      getResTagInfo: false,
      restagid: false,
      twlist: [],
      tablist: [
        {
          name: '职位生成',
          id: 1,
        },
        {
          name: 'AI问答',
          id: 2,
        },
        {
          name: '简历分析',
          id: 3,
        },
      ],
    }
  },
  updated:function(){
    this.$nextTick(function(){
    var div = document.getElementById('box-card1');
    div.scrollTop = div.scrollHeight;
    })
  },
  watch: {},
  created: function () {
    this.getTwList()
  },
  methods: {
    handleClick(tab, event) {
        this.activeName = tab
    },
    changeTab: function (id) {
      let that = this
      that.setid = id
    },
    goTestRes: function () {
      this.dialogVisible = true
    },
    handleAvatarSuccess: function (response, file, fileList) {
      let that = this
      that.resinfo = response.msg
      that.dialogVisible = false
      this.$refs.upload.clearFiles() //清空上传列表
      that.getEnd()
    },
    getEnd: function () {
      this.$message({
        message: '正在努力读取中',
        type: 'warning',
        duration: 0,
      })
      let that = this
      this.loading = true

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append(
        'jd',
        `${that.posinfo.des2.titel}:${that.posinfo.des2.content},${that.posinfo.des3.titel}:${that.posinfo.des3.content}`
      )
      urlencoded.append(
        'resinfo',
        `年龄：${that.resinfo.basic_info.age}岁，学历：${that.resinfo.basic_info.degree}，工作年限：${that.resinfo.basic_info.num_work_experience}，工作简介：${that.resinfo.work_experience[0].description}，`
      )
      urlencoded.append('user', localStorage.getItem('token'))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getEnd', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          Message.closeAll()
          that.loading = false
          console.log(result)
          let posres = JSON.parse(result).msg
          that.$alert(posres, '结果', {
            confirmButtonText: '确定',
          })
        })
        .catch((error) => {
          Message.closeAll()
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    handleAvatarSuccess1: function (response, file, fileList) {
      let that = this
      that.resinfo = response.msg
      that.dialogVisible = false
      this.$refs.upload.clearFiles() //清空上传列表
    },
    getResTag: function () {
      this.$message({
        message: '正在努力读取中',
        type: 'warning',
        duration: 0,
      })
      let that = this
      this.loading = true

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append(
        'resinfo',
        `年龄：${
          that.resinfo.basic_info.age ? that.resinfo.basic_info.age + '岁' : ''
        }，学历：${that.resinfo.basic_info.degree}，工作年限：${
          that.resinfo.basic_info.num_work_experience
        }，`
      )
      urlencoded.append('id', that.resinfo._id)
      urlencoded.append(
        'resinfo1',
        `职位名称：${that.resinfo.work_experience[0].job_title},在职时间：${that.resinfo.work_experience[0].start_time_year} ~ ${that.resinfo.work_experience[0].end_time_year},工作简介：${that.resinfo.work_experience[0].description}，`
      )
      urlencoded.append(
        'resinfo2',
        that.resinfo.work_experience.length > 1
          ? `职位名称：${that.resinfo.work_experience[1].job_title},在职时间：${that.resinfo.work_experience[1].start_time_year} ~ ${that.resinfo.work_experience[1].end_time_year},工作简介：${that.resinfo.work_experience[1].description}，`
          : 'null'
      )
      urlencoded.append('user', localStorage.getItem('token'))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getResTag', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          Message.closeAll()
          that.loading = false
          console.log(result)
          let posres = JSON.parse(result).msg
          that.restagid = posres
          that.getResTagById(posres)

        })
        .catch((error) => {
          Message.closeAll()
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getResTagById: function (id) {
      let that = this

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('user', localStorage.getItem('token'))
      urlencoded.append('id', id)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getResTagById', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          console.log(result)
          let posresg = JSON.parse(result).msg
          that.getResTagInfo =  posresg

                    // that.$alert(posres, '结果', {
          //   confirmButtonText: '确定',
          // })

          if (!posresg.res || posresg.res && posresg.res === '' ) {
            that.getResTagById(id)
          }
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    gosendPos: function (id) {
      localStorage.setItem('gptJd', JSON.stringify(this.posinfo))
      this.$router.push({ path: '/newPost?isai=true' })
    },
    getJd: function () {
      let that = this
      if (this.posname === '') {
        this.$message({
          message: '请输入职位名称',
          type: 'warning',
        })
      } else {
        this.loading = true

        var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

        var urlencoded = new URLSearchParams()
        urlencoded.append('text', this.posname)
        urlencoded.append('user', localStorage.getItem('token'))

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow',
        }

        fetch(' https://api.qilinpin.cn/gptapi/api/getJd', requestOptions)
          .then((response) => response.text())
          .then((result) => {
            that.loading = false
            that.posloading = true
            console.log(result)
            let posres = JSON.parse(result).msg
            that.posinfoid = posres
            that.getJdById(posres)
          })
          .catch((error) => {
            that.loading = false
            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
            console.log('error', error)
          })
      }
    },
    getYhRes: function (index,text) {
      this.$message({
          showClose: true,
          message: 'AI优化中'
        });
      let that = this

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('text', text)
      urlencoded.append('user', localStorage.getItem('token'))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getYhRes', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false
          let res = JSON.parse(result).msg
          that.resinfo.work_experience[index].description = res
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getYhRes1: function (index,text) {
      this.$message({
          showClose: true,
          message: 'AI优化中'
        });
      let that = this

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('text', text)
      urlencoded.append('user', localStorage.getItem('token'))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getYhRes', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false
          let res = JSON.parse(result).msg
          that.resinfo.project_experience[index].description = res
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getJdById: function (id) {
      let that = this

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('user', localStorage.getItem('token'))
      urlencoded.append('id', id)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getJdById', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          console.log(result)
          let posresg = JSON.parse(result).msg
          if (posresg === "ok") {
            setTimeout(()=>{
              that.getJdById(id)
            },1000)
          } else {
            that.posloading = false
            let pos = {}
            let posres = posresg
          for (let i in posres) {
            if (posres[i][0] === '岗位名称') {
              pos.des1 = {
                titel: '岗位名称',
                content: posres[i][1],
              }
            } else if (posres[i][0] === '岗位职责') {
              pos.des2 = {
                titel: '岗位职责',
                content: posres[i][1],
              }
            } else if (posres[i][0] === '岗位要求') {
              pos.des3 = {
                titel: '岗位要求',
                content: posres[i][1],
              }
            } else if (posres[i][0] === '岗位关键词') {
              pos.des4 = {
                titel: '岗位关键词',
                content: posres[i][1],
              }
            } else if (posres[i][0] === '岗位类别') {
              pos.des5 = {
                titel: '岗位类别',
                content: posres[i][1],
              }
            }
          }
          that.posinfo = pos
          }
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getResByname: function (posinfo) {
      debugger
      let that = this
      this.loading = true

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('text', [posinfo.des1.content,...posinfo.des4.content.split('、')])

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getResByTag', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false
          let res = JSON.parse(result).msg
          that.tjres = res
          debugger
          if (res.length > 0) {
            that.activeName = res[0]._id
          }
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getTw: function () {
      let that = this
      if (this.tw === '') {
        this.$message({
          message: '请输入你的问题',
          type: 'warning',
        })
      } else {
        this.loading = true

        var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

        var urlencoded = new URLSearchParams()
        urlencoded.append('text', this.tw)
        urlencoded.append('user', localStorage.getItem('token'))

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow',
        }

        fetch(' https://api.qilinpin.cn/gptapi/api/getTw', requestOptions)
          .then((response) => response.text())
          .then((result) => {
            that.loading = false
            let res = JSON.parse(result).msg
            that.twinfo = res
          })
          .catch((error) => {
            that.loading = false
            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
            console.log('error', error)
          })
      }
    },
    getTwList: function () {
      let that = this
      var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

        var urlencoded = new URLSearchParams()
        urlencoded.append('user', localStorage.getItem('token'))

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow',
        }

        fetch(' https://api.qilinpin.cn/gptapi/api/getTwList', requestOptions)
          .then((response) => response.text())
          .then((result) => {
            let res = JSON.parse(result).msg
            that.twlist  = res
            setTimeout(()=>{
              that.getTwList()
            },1000)
          })
          .catch((error) => {
            that.loading = false
            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
            console.log('error', error)
          })
    },
    createLtDoc: function () {
        this.$message({
          showClose: true,
          message: '数据下载完毕，正在生成报告中'
        });
        let resinfo = this.resinfo
        let that = this
        let filename = '/lietoubaogaoDemo.docx'
        loadFile(filename, function (
            error,
            content
        ) {
          debugger
            if (error) {
                throw error;
            }
            debugger
            var zip = new PizZip(content);
            debugger
            var doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true
            });
            debugger
            let data = {
              AI_text: that.getResTagInfo.res === "" ? "_____" : that.getResTagInfo.res,
              realname: resinfo.basic_info.name === "" ? "_____" : resinfo.basic_info.name,
              age: resinfo.basic_info.age === "" ? "_____" : resinfo.basic_info.age,
              sex: resinfo.basic_info.gender === "" ? "_____" : resinfo.basic_info.gender,
              hunpei: "_____",
              address: "_____",
              phone: resinfo.contact_info.phone_number === "" ? "_____" : resinfo.contact_info.phone_number,
              email: resinfo.contact_info.email === "" ? "_____" : resinfo.contact_info.email,
              edu_history: '',
              work_history: '',
              project_info: ''
            }
            let education_experience = resinfo.education_experience
            let edutext = ''
            for (let i in education_experience) {
              edutext += `${education_experience[i].start_time_year}.${education_experience[i].start_time_month}-${education_experience[i].end_time_year}.${education_experience[i].end_time_month}     ${education_experience[i].school_name}     ${education_experience[i].major}     ${education_experience[i].degree}\n\n`
            }
            data.edu_history = edutext
            let work_experience = resinfo.work_experience
            let worktext = ''
            for (let i in work_experience) {
              worktext += `${work_experience[i].start_time_year}.${work_experience[i].start_time_month}-${work_experience[i].end_time_year === "" ? "_" : work_experience[i].end_time_year}.${work_experience[i].end_time_month === "" ? "_" : work_experience[i].end_time_month}     ${work_experience[i].company_name}\n职位:${work_experience[i].job_title}\n工作职责:\n${work_experience[i].description}\n\n\n`
            }
            data.work_history = worktext
            let project_experience = resinfo.project_experience
            let projecttext = ''
            for (let i in project_experience) {
              projecttext += `${project_experience[i].start_time_year}.${project_experience[i].start_time_month}-${project_experience[i].end_time_year === "" ? "_" : project_experience[i].end_time_year}.${project_experience[i].end_time_month === "" ? "_" : project_experience[i].end_time_month}     ${project_experience[i].project_name}\n项目职责:\n${project_experience[i].description}\n\n\n`
            }
            data.project_info = projecttext
            debugger
            doc.setData(data);
            try {
                // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
                doc.render();
            
            } catch (error) {
              debugger
                console.log(JSON.stringify({ error: error }, that.replaceErrors));
                if (error.properties && error.properties.errors instanceof Array) {
                    const errorMessages = error.properties.errors
                        .map(function (error) {
                            return error.properties.explanation;
                        })
                        .join('\n');
                    console.log('errorMessages', errorMessages);
                }
                throw error;
            }
            var out = doc.getZip().generate({
                type: 'blob',
                mimeType:
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            });
            saveAs(out, `聘快快推荐报告 ${resinfo.basic_info.name}.docx`);
        });
    }
  },
  mounted: function () {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.ai {
  min-width: 100vw;
  flex: 1;
  padding-top: 1px;
  position: relative;
  background-color: #e6e6e6;

  .udpc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .box-card {
    margin-top: 60px;
    width: 800px;
    .text1 {
      margin: 10px 0;
      font-weight: bold;
    }
    .text {
      margin: 10px 0;
      line-height: 1.5;
      white-space: pre-line;
    }
  }

  .scbox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .box-card1{
      height: 60vh;
      overflow-y: scroll;
    }
    .tbox{

      .myinfo{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;
        .name{
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: flex-start;
        }
        .textbox{
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
          width: 70%;
          background-color: #b7deed;
          padding: 20px 15px;
          border-radius: 5px;
          margin-top: 10px;
        }
      }

      .gptinfo{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .name{
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
        }
        .textbox{
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
          width: 70%;
          background-color: #b7deed;
          padding: 20px 15px;
          border-radius: 5px;
          margin-top: 10px;
        }
      }
    }
    .twbox{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin: 20px 0 0 0;
      .scbtn{
        margin: 0;
      }
    }
    .scbtn {
      margin-top: 50px;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
    .el-upload-dragger {
      width: 178px;
      height: 178px;
    }
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .paginationBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ffffff;
    width: max-content;
    padding: 5px 40px;
    z-index: 9999;
    border-radius: 10px;

    .el-pager {
      li {
        background: transparent;
        color: #5dc2d0;
      }

      .active {
        background: #fff;
        color: #5dc2d0;
      }
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;

      i {
        color: #ffffff;
      }
    }
  }
  .cont {
    width: 100vw;
    height: calc(100%);
    border-radius: 8px;
    box-sizing: border-box;
    // overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    .selectCont {
      width: 311px;
      background-color: #ffffff;
      box-sizing: border-box;
      margin-top: 30px;
      padding: 35px 22px;
      border-radius: 10px;
      margin-left: 20px;

      .addbtn {
        background-color: #5dc1cf;
        color: #fff;
        margin-right: 20px;
        width: 262px;
        height: 40px;
        border-radius: 5px;
        line-height: 40px;
        text-align: center;
        margin-bottom: 20px;
        cursor: pointer;

        i {
          margin-right: 5px;
        }
      }

      .resitem {
        width: 262px;
        height: 77px;
        border-radius: 10px;
        border: 1px solid #5dc1cf;
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 10px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .p1 {
          font-size: 18px;
          color: #5dc1cf;
        }

        .avatersss {
          width: 50px;
          height: 50px;
          border-radius: 100%;
        }
      }

      .resitemactive {
        background-color: #5dc1cf;

        .p1 {
          font-size: 18px;
          color: #ffffff;
        }

        .p2 {
          font-size: 12px;
          color: #ffffff;
        }
        .p3 {
          font-size: 12px;
          color: #ffffff;
        }
      }
    }

    .tableCont {
      flex: 0.9;
      margin-top: 30px;
      box-sizing: border-box;
      background-color: #ffffff;
      margin-right: 20px;
      border-radius: 10px;
      padding: 30px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      .topbtnbox {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        width: 90%;

        .editbtn {
          background-color: #5dc1cf;
          color: #fff;
          margin-right: 20px;
          width: 100px;
          height: 40px;
          border-radius: 5px;
          line-height: 40px;
          text-align: center;
          cursor: pointer;

          i {
            margin-right: 5px;
          }
        }

        .delbtn {
          background-color: red;
          color: #fff;
          margin-right: 20px;
          width: 100px;
          height: 40px;
          border-radius: 5px;
          text-align: center;
          cursor: pointer;

          i {
            margin-right: 5px;
          }
        }
      }

      .avaters {
        width: 150px;
        height: 150px;
        border-radius: 100%;
      }

      .name {
        color: #4d4848;
        width: fit-content;
        margin-top: 20px;
      }

      .tagbox {
        margin-top: 20px;
        .el-tag {
          margin: 0 10px;
        }
      }

      .gstjbox {
        margin-top: 30px;
        display: flex;
        width: 610px;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        .gstj {
          color: #8c939d;
        }
      }

      .bt {
        width: 90%;
        font-size: 20px;
        font-weight: bold;
        padding-left: 20px;
        height: 26px;
        line-height: 26px;
        border-left: 5px solid #5dc1cf;
        margin-bottom: 30px;
        margin-top: 30px;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .btn {
          cursor: pointer;
          width: 120px;
          height: 36px;
          font-size: 18px;
          line-height: 36px;
          border-radius: 36px;
          background-color: #5dc1cf;
          color: #ffffff;
          text-align: center;
        }
      }

      .fkBox {
        width: 90%;
        padding: 30px;
        box-sizing: border-box;
        border-radius: 10px;
        background-color: #c0ac584d;
        margin: 30px auto;

        .title {
          color: #4d4d4d;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .tip {
          color: #4d4d4d;
        }

        .tipbox {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          margin: 0px 0 30px 0;
          .boxtop {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            width: 100%;
            .topp1 {
              color: #4d4d4d;
              font-size: 18px;
              font-weight: bold;
              margin-right: 20px;
              cursor: pointer;
            }
            .topp2 {
              color: #4d4d4d;
              font-size: 18px;
              font-weight: bold;
              cursor: pointer;
            }
            .close {
              color: red;
            }
            .pass {
              color: green;
            }
          }
          .boxbottom {
            margin-bottom: 20px;
            color: #4d4d4d;
          }
        }
      }
    }
  }
}
</style>
